import moment from "moment";

// HUB-2837: scheduled maintenance downtime window (Eastern Time, EDT = UTC-4)
export const MAINTENANCE_START = "2026-09-11T18:00:00-04:00";
export const MAINTENANCE_END = "2026-09-14T08:00:00-04:00";

export function isMaintenanceActive() {
  return moment().isBetween(MAINTENANCE_START, MAINTENANCE_END);
}

export function isBeforeMaintenanceStart() {
  return moment().isBefore(MAINTENANCE_START);
}
